import { useMemo, useState } from 'react'
import { useDeepCompareEffect } from 'ahooks';
import ChartBubble from "@/pages/intelligence/components/ChartBubble";
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import usePieChartsHoverEffect from '@intelligence/components/Chart/hooks/usePieChartsHoverEffect';
import { getPieChartLabelBaseRich, formatPieChartLabel } from '@intelligence/utils/echartsUtils';
import { PIE_CHART_TOOLTIP_BASE_OPTION } from '@intelligence/utils/echartsConst';
import { ChartType } from '@intelligence/pages/TopCharts/_config/enums';

export default function usePieCharts(props: any) {
  const { tableSelection, showValperNotAutoper = false, pieTitle = '', topChartsType,
    pieData,  //有此参数的，代码通用，单饼图
    chartLoading,
    setChartLoading,
    chartType = 'pie',
    chartsInstance,
    titleNow,
    startDate,
    endDate,
    metric = '',
  } = props;

  // console.log('usePieCharts', props);

  //饼图数据结构改变
  const pieEchartsList = () => {
    let tempPieEcharts: any[] = [];
    let valueKey: any = '';
    switch (topChartsType) {
      case 'newrelease':
        valueKey = 'other_metric';
        break;
      // case 'stats-countries-pie':
      //   valueKey = 'value';
      //   break;
      default:
        valueKey = 'popularity';
        break;
    }
    if (topChartsType == 'newrelease') {
      tableSelection?.map((item: any, index: any) => {
        const metricList = item[valueKey] || [];
        if (Array.isArray(metricList) && metricList?.length > 0) {
          const metricObj = metricList?.find((item: any) => item.metric == metric);
          tempPieEcharts.push({
            name: item.name,
            value: metricObj ? metricObj.value : 0,
            type: 'pie',
          });
        }
      })
    } else {
      tableSelection?.map((item: any, index: any) => {
        tempPieEcharts.push({
          name: item.name,
          value: item[valueKey] ? item[valueKey] : 0,
          type: 'pie',
        });
      })
    }

    return tempPieEcharts;
  }

  //获取通用-饼图数据结构
  const getBarSeriesData = (data: any[]) => {
    return data?.map((item: any, i: number): any => ({
      name: item.name || item.market,
      value: item.value ? item.value : 0,
      // cover: item.cover,
      itemStyle: {
        color: ECHARTSCOLOR[i],
      },
      label: {
        show: true,
        position: 'top',
        color: '#444',
        distance: 4,
        fontSize: 12,
        // formatter: (params: any) => `${newMathFormat(Number(params.value), true)}`,
        formatter: formatPieChartLabel,
      }
    }));
  }

  const legendsCustomMade = (seriesData: any) => {
    return {
      type: 'scroll',
      orient: 'horizontal', //横向
      pageIconColor: '#000', //翻页箭头颜色
      selectedMode: true,
      pageIconSize: 12,
      pageTextStyle: {
        color: '#000', //翻页数字颜色
      }, //翻页数字设置
      show: true,
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      bottom: 0,
      left: 'center',
      textStyle: {
        color: '#888888',
        fontSize: 12,
      },
      itemGap: 20,//图例之间间距20
      // 解决多条数据存在相同游戏名称的问题，利用唯一id来
      formatter: (name: any) => {
        let showText = seriesData?.find((v: any) => v?.name == name)?.name;
        return showText;
      }
    }
  }

  const [pieOption, setPieOption] = useState<any>(null);

  usePieChartsHoverEffect({
    loading: chartLoading,
    chartType,
    chartsInstance,
    setOption: setPieOption,
  });

  useDeepCompareEffect(() => {
    if (setChartLoading && chartType === ChartType.Pie) setChartLoading(false);
    const pieOptionTmp = {
      // calculable: true,
      color: ECHARTSCOLOR,
      legend: pieData ? legendsCustomMade(pieData) : {
        bottom: 10,
        icon: 'circle',
        itemWidth: 20,
        itemHeight: 10,
        left: 'center',
        orient: 'horizontal', //横向
        pageIconColor: '#ff781f', //翻页箭头颜色
        pageIconSize: 13,
        pageTextStyle: {
          color: '#999', //翻页数字颜色
        }, //翻页数字设置
        type: 'scroll',
        selectedMode: true,
        show: true,
        textStyle: {
          color: '#888888',
          fontSize: 12,
        },
      },
      title: {
        text: pieTitle,
        left: "center",
        top: "43%",
        textStyle: {
          fontWeight: 600,
          fontSize: 12,
          color: '#262832',
          width: 100,
          overflow: 'truncate',
        }
      },
      tooltip: {
        ...PIE_CHART_TOOLTIP_BASE_OPTION,
        formatter: (params: any) => {
          return ChartBubble({
            chartType,
            titleNow,
            startDate,
            endDate,
            data: params,
          });
        },
        backgroundColor: 'rgba(0,0,0,0)',
      },
      series: {
        avoidLabelOverlap: true,
        type: 'pie',
        radius: [55, 95],
        center: ['50%', '50%'],
        bottom: 20,
        label: {
          normal: {
            formatter: (params: any) => {
              const name = params?.name;
              const value = params?.value;
              //本地环境可能辨别不出undefined的情况， 然而打包后的test有undefined情况
              const percent = params?.percent === undefined ? 0 : params?.percent;
              return showValperNotAutoper ? `${name}:  {per|${value}%}\n{hr|}\n{a|}` : `${name}:  {per|${percent}%}\n{hr|}\n{a|}`
            },
            padding: [0, -6], //取消hr线跟延长线之间的间隙
            rich: {
              ...getPieChartLabelBaseRich(),
            },
          },
        },
        labelLine: {
          // 折线弯曲程度配置
          length: 20,
          showAbove: false,
          // minTurnAngle: 80,
          maxSurfaceAngle: 80,
          lineStyle: {
            width: 2,
          },
        },
        itemStyle: {
          borderRadius: 5,
          borderColor: '#fff',
          borderWidth: 1,
        },
        minAngle: 10,
        data: pieData ? getBarSeriesData(pieData) : pieEchartsList()?.map((litem: any) => {
          return {
            name: litem.name,
            value: litem.value,
            itemStyle: {
              color: litem.color,
            },
          }
        }),
      },
      graphic: [{
        type: 'text',
      }],
    };
    setPieOption(pieOptionTmp);
  }, [props]);

  return {
    pieOption
  };
}
